// Shared presentational pieces for rendering notifications consistently across
// NotificationHistorySection, NotificationDetailsDialog and NotificationManagement.

export const STATUS_CONFIG = {
  sent:      { label: 'Sent',      color: '#6366f1', bg: '#eef2ff' },
  delivered: { label: 'Delivered', color: '#059669', bg: '#d1fae5' },
  opened:    { label: 'Opened',    color: '#0284c7', bg: '#e0f2fe' },
  deferred:  { label: 'Deferred',  color: '#d97706', bg: '#fef3c7' },
  bounced:   { label: 'Bounced',   color: '#dc2626', bg: '#fee2e2' },
  blocked:   { label: 'Blocked',   color: '#7c3aed', bg: '#ede9fe' },
  spam:      { label: 'Spam',      color: '#b45309', bg: '#fef9c3' },
  invalid:   { label: 'Invalid',   color: '#6b7280', bg: '#f3f4f6' },
  failed:    { label: 'Failed',    color: '#dc2626', bg: '#fee2e2' },
};

export const StatusBadge = ({ status }) => {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.sent;
  return (
    <span style={{
      display: 'inline-block',
      padding: '2px 10px',
      borderRadius: 99,
      fontSize: 12,
      fontWeight: 600,
      color: cfg.color,
      background: cfg.bg,
      whiteSpace: 'nowrap',
    }}>
      {cfg.label}
    </span>
  );
};

export const TypeBadge = ({ type }) => (
  <span style={{
    display: 'inline-block',
    padding: '2px 10px',
    borderRadius: 99,
    fontSize: 12,
    fontWeight: 600,
    color: type === 'email' ? '#0284c7' : '#059669',
    background: type === 'email' ? '#e0f2fe' : '#d1fae5',
    whiteSpace: 'nowrap',
  }}>
    {type === 'email' ? '✉ Email' : '💬 WhatsApp'}
  </span>
);

export const formatDateTime = (dateStr) => {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleString('en-IN', {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
};

export const thStyle = {
  padding: '8px 12px',
  textAlign: 'left',
  fontWeight: 600,
  fontSize: 12,
  color: '#374151',
  borderBottom: '1px solid #e5e7eb',
  whiteSpace: 'nowrap',
};

export const tdStyle = {
  padding: '8px 12px',
  verticalAlign: 'middle',
};

export const RecipientTable = ({ recipients }) => (
  <div style={{ margin: '12px 0 4px', overflowX: 'auto' }}>
    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
      <thead>
        <tr style={{ background: '#f9fafb' }}>
          <th style={thStyle}>Student</th>
          <th style={thStyle}>Contact</th>
          <th style={thStyle}>Status</th>
          <th style={thStyle}>Updated At</th>
        </tr>
      </thead>
      <tbody>
        {recipients.map((r, i) => (
          <tr key={i} style={{ borderBottom: '1px solid #f3f4f6' }}>
            <td style={tdStyle}>{r.name || '—'}</td>
            <td style={{ ...tdStyle, color: '#6b7280', fontSize: 12 }}>{r.contact || '—'}</td>
            <td style={tdStyle}><StatusBadge status={r.status} /></td>
            <td style={{ ...tdStyle, color: '#6b7280', fontSize: 12, whiteSpace: 'nowrap' }}>
              {r.statusUpdatedAt ? formatDateTime(r.statusUpdatedAt) : '—'}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const statusSummary = (notif) => {
  if (!notif.recipients || notif.recipients.length === 0) return null;
  const counts = {};
  notif.recipients.forEach((r) => {
    counts[r.status] = (counts[r.status] || 0) + 1;
  });
  return Object.entries(counts)
    .map(([status, count]) => <StatusBadge key={status} status={status} />)
    .slice(0, 3);
};

const ENTITY_LABELS = { student: 'Student', batch: 'Batch', course: 'Course' };
const ENTITY_PATHS = { student: '/students', batch: '/batches', course: '/courses' };

export const EntityBadge = ({ entityType }) => (
  <span style={{
    display: 'inline-block',
    padding: '2px 10px',
    borderRadius: 99,
    fontSize: 12,
    fontWeight: 600,
    color: '#475569',
    background: '#f1f5f9',
    whiteSpace: 'nowrap',
  }}>
    {ENTITY_LABELS[entityType] || entityType}
  </span>
);

export const entityLink = (notif) => {
  const base = ENTITY_PATHS[notif.entityType];
  if (!base || !notif.entityId) return null;
  return `${base}/${notif.entityId}`;
};
